// useMessageDetailType.js
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';

import getMessageData from '../selector/getMessageData.js';
import getAssetData from '../selector/getAssetData.js';
import getMessageDetailLayout from '../selector/getMessageDetailLayout.js';
import getNetworkingData from '../selector/getNetworkingData.js';

import fetchAssetManifest from '../action/fetchAssetManifest.js';
import fetchMessageDetail from '../action/fetchMessageDetail.js';

export function useMessageDetailType() {
  const { messageId } = useParams();
  const dispatch = useDispatch();
  const assetIds =
    useSelector(state => getMessageData(state, messageId, 'assetIds')) || [];
  const hasAssetIds = assetIds.length;
  const firstAssetId = assetIds[0];
  const firstAssetContentType =
    useSelector(state => getAssetData(state, [firstAssetId], 'contentType')) ||
    '';
  const duration = useSelector(state =>
    getAssetData(state, [firstAssetId, 'duration'])
  );
  const isFetching = useSelector(state =>
    getNetworkingData(state, ['messages', messageId, 'detail'], 'isFetching')
  );
  const isFetched = useSelector(state =>
    getNetworkingData(state, ['messages', messageId, 'detail'], 'isFetched')
  );

  const isVideo = firstAssetContentType.startsWith('video/');
  useEffect(() => {
    if (!messageId) return;
    if (!hasAssetIds && !isFetching && !isFetched) {
      dispatch(fetchMessageDetail({ id: messageId }));
    }
    if (isVideo && !duration && hasAssetIds) {
      dispatch(fetchAssetManifest({ messageId, assetId: firstAssetId }));
    }
  }, [
    messageId,
    hasAssetIds,
    firstAssetId,
    duration,
    isVideo,
    isFetching,
    isFetched,
    dispatch,
  ]);

  return useSelector(state => getMessageDetailLayout(state, messageId));
}

export default useMessageDetailType;
